import { $httpFhirApi } from '@/common/api/httpFhir.service';

// Merge BN_Relationship data into a participant-id-to-display map.
// BN_Relationship entries take precedence over CareTeam roles.
function mergeBnRelationships(data, map) {
    data?.forEach((rel) => {
        if (rel.related?.id && rel.relationship?.length) {
            const display = rel.relationship[0]?.display ?? rel.relationship[0]?.code;
            if (display) map[rel.related.id] = display;
        }
    });
}

// Merge CareTeam participant roles into a participant-id-to-display map.
// Only sets a value if one doesn't already exist (BN_Relationship takes precedence).
function mergeCareTeamRoles(data, map) {
    data?.filter((ct) => ct.resourceType === 'CareTeam' && ct.participant?.length).forEach((ct) => {
        ct.participant.forEach((member) => {
            if (member.member?.id && member.role?.length && !map[member.member.id]) {
                const display = member.role
                    .map((r) => r.text || r.coding?.[0]?.display)
                    .filter(Boolean)
                    .join(', ');
                if (display) map[member.member.id] = display;
            }
        });
    });
}

// Fetch BN_Relationship and CareTeam data for a patient and merge into the provided map.
async function fetchRelationshipsForSubject(subjectId, map) {
    const [relRes, ctRes] = await Promise.all([$httpFhirApi.get('BN_Relationship?subject=' + subjectId), $httpFhirApi.get('CareTeam?patient=' + subjectId + '&_elements=participant')]);
    mergeBnRelationships(relRes?.data, map);
    mergeCareTeamRoles(ctRes?.data, map);
}

// Format credentials value into a display string.
// Handles both plain strings and CodeableConcept arrays.
function formatPractitionerCredentials(credentials) {
    if (!credentials) return null;
    if (Array.isArray(credentials)) {
        const str = credentials
            .map((c) => c?.coding?.[0]?.display ?? c?.text ?? c?.display)
            .filter(Boolean)
            .join(', ');
        return str || null;
    }
    return credentials;
}

// Build a "jobTitle, credentials" display string from a practitioner-like object.
function buildJobTitleCredentials({ jobTitle, credentials }) {
    const credStr = formatPractitionerCredentials(credentials);
    const parts = [jobTitle, credStr].filter(Boolean);
    return parts.length ? parts.join(', ') : null;
}

export { mergeBnRelationships, mergeCareTeamRoles, fetchRelationshipsForSubject, formatPractitionerCredentials, buildJobTitleCredentials };
